import React, { Component } from "react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";

import Mailchimp from "react-mailchimp-form";
//import { AUTH_TOKEN, USERNAME } from '../constants';
import Cookies from "universal-cookie";

const cookies = new Cookies();

const SUB_QUERY = gql`
  query subsribe {
    themeGeneralSettings {
      optionsPage {
        newsletterSubscribeText
        newsletterSubscribeTextEn
        eMailEn
        eMailLv
        registerEn
        registerLv
      }
    }
  }
`;

class Subscribe extends Component {
  state = {
    dataq: []
  };

  componentDidMount() {
    this.executeNav();
  }

  executeNav = async () => {
    const { client } = this.props;
    const result = await client.query({
      query: SUB_QUERY
    });
    const dataq = result.data.themeGeneralSettings.optionsPage;
    this.setState({ dataq });
  };

  render() {
    const { dataq } = this.state;
    var eMailLang = dataq.eMailLv;
    var registerLang = dataq.registerLv;
    var subscribeLang = dataq.newsletterSubscribeText;
    if (cookies.get("lang") === "LV") {
      eMailLang = dataq.eMailLv;
      registerLang = dataq.registerLv;
      subscribeLang = dataq.newsletterSubscribeText;
    }
    if (cookies.get("lang") === "EN") {
      eMailLang = dataq.eMailEn;
      registerLang = dataq.registerEn;
      subscribeLang = dataq.newsletterSubscribeTextEn;
    }
    // const url = "//kanepes.us16.list-manage.com/subscribe/post?u=10e1dbcfba4c09a86d3395d0d&id=85226f01ff";

    return (
      <div className="subscribe-wrap my-5">
        <div className="container grid">
          <div className="newsletter_row align-items-center">
            <div className="newsletter_subscribe_text">
              {subscribeLang}
            </div>
            <div className="newsletter_input">
              <Mailchimp
                action='//kanepes.us5.list-manage.com/subscribe/post?u=10e1dbcfba4c09a86d3395d0d&id=85226f01ff'
                fields={[
                  {
                    name: "EMAIL",
                    placeholder: eMailLang,
                    type: "email",
                    required: true
                  }
                ]}
                messages={{
                  sending: "...",
                  success: "Paldies!",
                  error: "?",
                  empty: "?",
                  duplicate: "Esi jau reģistrējies",
                  button: registerLang
                }}
                // Add a personalized class
                className="mailchimp"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withApollo(Subscribe);
